module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("My Journey to Love and Back to Life")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch001#about-the-author"
    }
  }, [_vm._v("About The Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch003#copyright-information",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch004#it-goes-on",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It Goes On")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch005#judge-me",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judge Me")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#your-touch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Your Touch")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch007#more-than-this",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Than This")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#my-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Day")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#we-forget-mum",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("We Forget (Mum)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#i-can-do-this",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Can Do This")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch011#always-in-my-head",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Always in My Head")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#please-watch-over-me-lord",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Please Watch Over Me, Lord")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch013#reality-is-strange",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reality Is Strange")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch014#maybe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maybe")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch015#give-up-my-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Give up My Life")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch016#old-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Man")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch017#the-most-beautiful-one-i-knew-for-two-weeks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Most Beautiful One I Knew for Two Weeks")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch018#so-who-can-say",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("So Who Can Say")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch019#devils-bridge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devil’s Bridge")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch020#calm-in-the-chaos-oh-lord",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Calm in the Chaos, Oh Lord")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch021#someone-not-to-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Someone Not to Love")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch022#the-moon-and-my-doubts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Moon and My Doubts")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch023#oh-you-beautiful-earth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oh You Beautiful Earth")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch024#another-book",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Another Book")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch025#its-all-i-have",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s All I Have")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch026#matilda",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matilda")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch027#please-say-yes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Please Say Yes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch028#home-alone",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home Alone")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch029#the-world-and-all-its-beauty",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World and All Its Beauty")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch030#soul-searching",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soul Searching")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch031#mill-bay",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mill Bay")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch032#waiting-for",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting For")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch033#the-last-advice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Advice")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch034#i-understand",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Understand")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch035#why",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch036#my-beautiful-sister",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Beautiful Sister")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch037#oh-that-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oh That Love")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch038#let-it-not-be",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let It Not Be")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch039#living-after-loving-is-not-for-cowards",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Living After Loving Is Not for Cowards")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch040#gypsy-lane",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gypsy lane")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch041#the-room-inside-my-mind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Room Inside My Mind")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch042#my-sweet-lord",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Sweet Lord")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch043#love-and-losses",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love and Losses")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-200"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch043#Head",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Head on My Pillow\n(Sweet, Sweet Jesus)\n")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch044#so-in-my-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("So in My Life")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch045#i-just-needed-to-look-back-from-afar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Just Needed to Look Back from Afar")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch046#im-tired",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I’m Tired")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch047#glimmer-of-hope-father",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glimmer of Hope (Father)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch048#oh-brother",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oh Brother")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch049#who-put",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Put")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch050#is-this-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is This Love?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch051#please-love-me",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Please Love Me")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch052#how-many",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How Many?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch053#choices",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choices")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch054#my-weeping-cross",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Weeping Cross")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch055#under-the-stars",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Under the Stars")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch056#mr-livesy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mr Livesy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch057#gentle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gentle")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch058#hole-in-the-road",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hole in the Road")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch059#rebel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rebel")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch060#colours",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colours")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch061#love-is-still-here",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love Is Still Here")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch062#death-can-wait",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death Can Wait")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch063#born-so-young",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Born So Young")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch064#theres-an-old-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There’s an Old Man")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch065#breaking-the-cycle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breaking the Cycle")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch066#free",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Free")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch067#forgot-to-say-thank-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forgot to Say Thank You")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch068#storm",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Storm")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch069#shouldve-told-me",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Should’ve Told Me")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch070#can-i-turn-to-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Can I Turn to You?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch071#words",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Words")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch072#no-goodbyes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Goodbyes")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch073#parting-is-no-fun",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parting Is No Fun")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch074#happy-behind-the-tears",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Happy Behind the Tears")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch075#shiva",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shiva")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch076#for-julie-in-august",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For Julie in August")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch077#lullaby",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lullaby")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch078#no-days",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Days")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch079#for-you-mum",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For You, Mum")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch080#wondrous-cross",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wondrous Cross")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch081#i-wish",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Wish")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch082#a-sunny-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Sunny Day")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch083#love-is-a-seed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love Is a Seed")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch084#the-black-dog-and-the-rainbo-depression",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Black Dog and the Rainbo (Depression)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch085#sad-little-emo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sad Little Emo")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch086#ireland",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ireland")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch087#the-cross-on-the-wall",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cross on the Wall")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch088#she-lives-by-the-sea-for-beth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("She Lives by the Sea (for Beth)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch089#life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch090#my-journey-to-love-and-back-to-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Journey to Love and Back to Life")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch091#fast-cars",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fast Cars")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch092#freedom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Freedom")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch093#the-blue-tides",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Blue Tides")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch094#time",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Time")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch095#tomorrow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tomorrow")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch096#the-test-of-time",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Test of Time")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch097#m42-bubbles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M42 Bubbles")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch098#no-losers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No Losers")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch099#do-not-wear-black",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do Not Wear Black")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb74dd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/nav.vue
// module id = 60
// module chunks = 0